export default "/36022bc732d21dcfe768d2a0d43278c292b1a1e5/48d0057cf54c678c61fc778c0aeda84f.svg";